module.exports = __webpack_public_path__ + "media/media/shop/item-3-4ceba2e3c66e83939eda9c1916303867.png";